// JS que dependiendo la variante de color seleccioneada cambia slider

$(document).ready(function(){
    // variables

    // acciones
    $('body').on('click', '.js-slide-variant__action', function(event) {
        slideVariant($(this))
    })

    function slideVariant(action) {
        $('.js-slide-variant__variant').each( function (){
            if ( action.data('slide-variant__id') == $(this).data('slide-variant__id') ) {

                if ( $(this).data('slide-variant__variant').includes(action.data('slide-variant__variant')) ) {
                    $(`.${action.data('slide-variant__slide')}`).slick('slickGoTo', `${$(this).data('slide-variant__position')}`)
                }

            }
        })
    }

})